import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults, getLeft, getRight } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  item: {
    get height() {
      return theme.default.height;
    },
    get padding() {
      return "0 " + theme.default.padding;
    },
    get hoverBgColor() {
      return theme.color.bg;
    },
    // disabled
    get disabledBgColor() {
      return theme.color.disabledBg;
    },
    get disabledColor() {
      return theme.color.disabled;
    }
  },
  menu: {
    minWidth: '100px',
    bgColor: '#fff',
    get borderRadius() {
      return theme.borderRadius;
    },
    fontSize: '12px',
    get zIndex() {
      return theme.midZIndex;
    }
  }
};
var dropdown;
setDefault(function () {
  dropdown = deepDefaults(theme, {
    dropdown: defaults
  }).dropdown;
  makeMenuStyles == null || makeMenuStyles.clearCache();
  makeItemStyles == null || makeItemStyles.clearCache();
});
export var makeMenuStyles = cache(function makeMenuStyles(k) {
  return /*#__PURE__*/css("position:absolute;min-width:", dropdown.menu.minWidth, ";background:", dropdown.menu.bgColor, ";border-radius:", dropdown.menu.borderRadius, ";box-shadow:", theme.middleBoxShadow, ";font-size:", dropdown.menu.fontSize, ";z-index:", dropdown.menu.zIndex, ";top:0;left:0;.", k, "-dropdown{display:block;}");
});
export var makeItemStyles = cache(function makeItemStyles(k) {
  return /*#__PURE__*/css("padding:", dropdown.item.padding, ";cursor:pointer;white-space:nowrap;height:", dropdown.item.height, ";line-height:", dropdown.item.height, ";&.", k, "-hover{background:", dropdown.item.hoverBgColor, ";}&:first-of-type{border-radius:", dropdown.menu.borderRadius, " ", dropdown.menu.borderRadius, " 0 0;}&:last-of-type{border-radius:0 0 ", dropdown.menu.borderRadius, " ", dropdown.menu.borderRadius, ";}&.", k, "-disabled{background:", dropdown.item.disabledBgColor, ";color:", dropdown.item.disabledColor, ";cursor:not-allowed;}.", k, "-checkbox,.", k, "-radio{display:flex;margin:0 -", getRight(dropdown.item.padding), " 0 -", getLeft(dropdown.item.padding), ";padding:", dropdown.item.padding, ";}.", k, "-checkbox-wrapper,.", k, "-radio-wrapper{vertical-align:text-bottom;}.", k, "-checkbox-text,.", k, "-radio-text{vertical-align:baseline;}");
});